<template>
  <div class="hm-availability-schedule" v-if="availability">
    <span>{{ $t('PRODUCTS.LABELS.TIMEZONE') }}</span>
    <v-select
      :options="timezones"
      label="name"
      code="value"
      v-model="availability.timezone"
      :reduce="r => r.value"
    >
    </v-select>
    <div v-for="day in days" :key="day.day" class="my-3">
      <section
        class="d-flex flex-row justify-content-between align-items-start"
      >
        <div class="d-flex justify-content-start align-items-center">
          <HMSwitch
            class="mr-2"
            v-model="availability.rules[day.day].enabled"
            @change="dayToggled(day.day)"
          />
          <label class="day-label mr-4">{{ day.label }}</label>
        </div>
        <div
          v-if="availability.rules[day.day].enabled"
          class="intervals d-flex flex-column justify-content-start align-items-start"
        >
          <div
            class="d-flex flex-row justify-content-start align-items-center mb-2"
            v-for="(interval, index) in availability.rules[day.day].intervals"
            :key="index"
          >
            <HMTimePicker class="time-picker" v-model="interval.from" />
            <span class="mx-2">-</span>
            <HMTimePicker class="time-picker" v-model="interval.to" />
            <span
              class="remove-interval ml-4 pointer"
              @click="removeInterval(day.day, interval)"
            >
              <i class="far fa-trash-alt"></i>
            </span>
            <span
              v-if="index === availability.rules[day.day].intervals.length - 1"
              class="add-interval ml-5 pointer"
              @click="addInterval(day.day)"
            >
              <i class="far fa-plus"></i>
            </span>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { getDefaultAvailability } from '@/core/utils/products';
import HMSwitch from '@/web/components/common/HMSwitch';
import HMTimePicker from '@/web/components/common/HMTimePicker';
import timezones from '@/web/utils/timezones.ts';

export default {
  name: 'HMAvailabilitySchedule',
  components: { HMSwitch, HMTimePicker },
  props: {
    value: {
      type: Object,
    },
    timezone: {
      type: String,
    },
  },
  computed: {
    days() {
      return [
        { day: 'sunday', label: this.$t('GENERAL.CALENDAR.SUNDAY') },
        { day: 'monday', label: this.$t('GENERAL.CALENDAR.MONDAY') },
        { day: 'tuesday', label: this.$t('GENERAL.CALENDAR.TUESDAY') },
        { day: 'wednesday', label: this.$t('GENERAL.CALENDAR.WEDNESDAY') },
        { day: 'thursday', label: this.$t('GENERAL.CALENDAR.THURSDAY') },
        { day: 'friday', label: this.$t('GENERAL.CALENDAR.FRIDAY') },
        { day: 'saturday', label: this.$t('GENERAL.CALENDAR.SATURDAY') },
      ];
    },
  },
  data() {
    return {
      availability: null,
      timezones: timezones,
    };
  },
  methods: {
    dayToggled(day) {
      if (
        this.availability.rules[day].enabled &&
        this.availability.rules[day].intervals.length === 0
      ) {
        this.availability.rules[day].intervals.push({
          from: '09:00',
          to: '17:00',
        });
      }
    },
    addInterval(day) {
      this.availability.rules[day].intervals.push({
        from: '',
        to: '',
      });
    },
    removeInterval(day, interval) {
      this.availability.rules[day].intervals = this.availability.rules[
        day
      ].intervals.filter(i => i !== interval);
      if (this.availability.rules[day].intervals.length === 0) {
        this.availability.rules[day].enabled = false;
      }
    },
  },
  mounted() {
    this.availability = this.value;
    if (!this.availability) {
      this.availability = getDefaultAvailability();
      this.availability.timezone = this.timezone;
    }
  },
  watch: {
    availability: {
      handler() {
        this.$emit('input', this.availability);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.select-timezone {
  width: 300px;
  max-width: 100%;
}

.day-label {
  min-width: 100px;
  margin: 0;
}

.remove-interval,
.add-interval {
  &:hover {
    color: $coral;
  }
}

.time-picker {
  min-width: 140px;
}
</style>
